module.exports = __webpack_public_path__ + "img/price-banner-sm.6f3d50d9.png";